import { render, staticRenderFns } from "./FeedbackRootView.vue?vue&type=template&id=6835cd21"
import script from "./FeedbackRootView.vue?vue&type=script&lang=js"
export * from "./FeedbackRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports